import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { PoBreadcrumb, PoDatepickerIsoFormat, PoModalAction, PoModalComponent, PoPageFilter, PoSearchFilterMode, PoTableAction, PoTableColumn } from '@po-ui/ng-components';
import { PoStorageService } from '@po-ui/ng-storage';
import { FiltroRomaneioLista } from '../filter/filtro-romaneio-lista';
import { CabecalhoRomaneio } from '../interface/romaneio';
import { RomaneioService } from '../service/romaneio.service';

@Component({
  selector: 'app-romaneio-recebimento-lista',
  templateUrl: './romaneio-recebimento-lista.component.html',
  styleUrls: ['./romaneio-recebimento-lista.component.css']
})
export class RomaneioRecebimentoListaComponent implements OnInit {

  tabelaPrincipalItens: Array<any> = [];
  tabelaPrincipalFiltro: FiltroRomaneioLista;

  formatExtended: PoDatepickerIsoFormat = PoDatepickerIsoFormat.Extended;

  poSearchFilterMode: PoSearchFilterMode = PoSearchFilterMode.contains;

  constructor(
    private router: Router,
    private romaneioService: RomaneioService,
    private poStorageService: PoStorageService,
  ) {
    this.tabelaPrincipalFiltro = new FiltroRomaneioLista(this.poStorageService);
  }

  @ViewChild('advancedFilterModal', { static: true }) advancedFilterModal!: PoModalComponent;

  ngOnInit(): void {
    this.tabelaPrincipalLoad();
  }

  novoRomaneioNF(): void {
    this.router.navigateByUrl('/estoque/romaneio/nf-entrada/cadastro');
  }

  tabelaPrincipalLoad(): void {
    this.tabelaPrincipalFiltro.setStorage();
    this.tabelaPrincipalFiltro.dados.CZ00STATUS = '1';

    this.romaneioService.listaRecebimento(this.tabelaPrincipalFiltro.dados).subscribe((lista) => {
      this.tabelaPrincipalItens = lista.items;
    });
  }

  public readonly tabelaPrincipalColunas: Array<PoTableColumn> = [
    {property: 'CZ00COD'   , label: 'Código Romaneio' , width: '100px'},
    {property: 'DZ00DATA'  , label: 'Data'            , width: '10%', type: 'date', format: 'dd/MM/yyyy'},
    {property: 'CZ00DESTIN', label: 'Destino'         , width: '8%', type: 'label',
      labels: [
        { value: 'SO', color: 'color-01',  label: 'SOLIDA' },
        { value: 'BA', color: 'color-05',  label: 'CD SOLIDA' },
      ]
    },
    {property: 'CZ00PLACA' , label: 'Placa'           , width: '10%'},
    {property: 'CZ00USER'  , label: 'Usuário Criação' , width: '15%'},
    {property: 'CUSRNOME'  , label: 'Nome Usuário'    , width: '25%'},
    {property: 'CZ00HORA'  , label: 'Hora'            , width: '10%'},
    {property: 'CSTATUS'   , label: 'Status'          , width: '15%', type: 'label',
      labels: [
        { value: 'PR', color: 'color-08',  label: 'Pendente Recebimento'  },
        { value: 'RP', color: 'color-01',  label: 'Recebido Parcialmente' },
        { value: 'RE', color: 'color-12',  label: 'Recebido'              },
      ]
    },
    { property: 'itemsRomaneio', label: 'Details', type: 'detail',
      detail: {
        columns: [
          {property: 'CSTATUS', label: 'Status'},
          {property: 'CZ02LOTE', label: 'Etiqueta'},
          {property: 'CB1COD', label: 'Produto'},
          {property: 'CB1DESC', label: 'Descrição'},
          {property: 'NZ01QUANT', label: 'Quantidade'},
          {property: 'NZ02PESO', label: 'Peso'},
        ],
        typeHeader: 'top'
      }
    }
  ];

  public readonly tabelaPrincipalActions: Array<PoTableAction> = [
    {
      action: this.editar.bind(this),
      icon: 'po-icon-edit',
      label: 'Editar',
    },
  ];

  public readonly breadcrumb: PoBreadcrumb = {
    items: [
      { label: 'Recebimento Romaneio', action: this.goHome.bind(this) },
      { label: 'Lista' }
    ]
  };

  editar(row: CabecalhoRomaneio): void {
    this.router.navigateByUrl(`/estoque/romaneio/recebimento/${row.CZ00COD}`);
  }

  goHome(): void {
    this.router.navigateByUrl('');
  }

  //################################################################//
  // FILTRO
  //################################################################//
  public readonly filterSettings: PoPageFilter = {
    advancedAction: this.advancedFilterActionModal.bind(this),
  };

  advancedFilterActionModal(): void {
    this.advancedFilterModal.open();
  }

  public readonly advancedFilterPrimaryAction: PoModalAction = {
    action: () => {
      this.advancedFilterModal.close();
      this.tabelaPrincipalLoad();
    },
    label: 'Aplicar Filtros'
  };

}
